import {
  keepPreviousData,
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { createCaderno, fetchCaderno, fetchCadernos } from "../api/caderno";
import { stampHasCaderno } from "../lib/site-stamp";

export function cadernoOptions(id: number) {
  return queryOptions({
    queryKey: ["caderno", id],
    queryFn: () => fetchCaderno(id),
  });
}

export function cadernosOptions(page: number) {
  return queryOptions({
    queryKey: ["cadernos", page],
    queryFn: () => fetchCadernos(page),
    // Paging keeps the previous page on screen while the next one loads, so
    // the grid doesn't collapse to a skeleton on every click
    placeholderData: keepPreviousData,
  });
}

/**
 * Shared by the three flows: creates the caderno, then hands over to its page.
 * Navigation lives here so every flow lands on the Painel — except the chat's
 * Revisão final, which promised step 1 of its trilha.
 */
export function useCreateCaderno(landing: "painel" | "revisao" = "painel") {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCaderno,
    onSuccess: (caderno) => {
      // POST already returned the full caderno, so the page it lands on has no
      // reason to fetch it again
      queryClient.setQueryData(cadernoOptions(caderno.id).queryKey, caderno);

      // …but every page of the list is now one caderno short of the truth, and
      // a new caderno is newest-first, so it shifts them all. The bare
      // ["cadernos"] prefix matches every page at once.
      void queryClient.invalidateQueries({ queryKey: ["cadernos"] });

      // …e o header do site passa a ter caminho de regresso: o aluno que sai
      // daqui para um artigo encontra "Continuar no Lume" na pill, não um
      // convite a começar o que já começou (lib/site-stamp.ts).
      stampHasCaderno(true);

      if (landing === "revisao") {
        navigate({
          to: "/caderno/$cadernoId/trilha",
          params: { cadernoId: String(caderno.id) },
          search: { modo: "essencial" },
        });
        return;
      }

      navigate({
        to: "/caderno/$cadernoId",
        params: { cadernoId: String(caderno.id) },
      });
    },
  });
}
